import React, { useCallback, useMemo, useState } from 'react';

import { useGetNotificationsQuery } from 'api/main';
import { parseReceivedNotifications } from 'utils/helpers';
import { ORDER_BY, sortDirection } from 'utils/constants';
import { texts } from 'utils/languages/fr';

import PageWrapper from './PageWrapper';
import { CustomPagination, Loader, Message } from 'components';
import { Box, Typography } from '@mui/material';

const InvestorMessages = () => {
    const [page, setPage] = useState(1);
    const [expandedMessageId, setExpandedMessageId] = useState(null);
    const handleToggleExpand = useCallback(
        id => e => {
            setExpandedMessageId(prevState => (prevState === id ? null : id));
        },
        []
    );

    const {
        data: { notifications = [], lastPage } = { data: { notifications: [] } },
        isLoading: notificationsLoader,
    } = useGetNotificationsQuery({
        page,
        orderBy: ORDER_BY.createdAt,
        direction: sortDirection.DESC,
    });

    const messages = useMemo(
        () =>
            parseReceivedNotifications(
                notifications.map(n => n[0]),
                true
            ),
        [notifications]
    );

    const handlePageChange = useCallback(page => () => setPage(page), []);

    return (
        <PageWrapper title={texts.MY_MESSAGES}>
            <Loader loading={notificationsLoader}>
                {messages.length === 0 ? (
                    <Box textAlign="center">
                        <Typography>{texts.NO_MESSAGE}</Typography>
                    </Box>
                ) : (
                    <Box display="flex" flexDirection="column" gap={2}>
                        {messages.map(message => (
                            <Message
                                key={message.id}
                                id={message.id}
                                expanded={expandedMessageId === message.id}
                                onToggleExpand={handleToggleExpand(message.id)}
                                title={message.title}
                                content={message.content}
                                type={message.type}
                            />
                        ))}
                    </Box>
                )}
            </Loader>
            <CustomPagination
                currentPage={page}
                lastPage={lastPage}
                changePage={handlePageChange}
            />
        </PageWrapper>
    );
};

export default InvestorMessages;
